(function(){
    angular.module("tmx-app").directive('tmxmfAddress',[addressPartial]);

    function addressPartial(){
        var directive={
            scope:{
                model:"=",
                form:"="
            },
            templateUrl:"common/directives/tmxMFAddress/tmxmfaddress.html",
            controller:["$scope",addressCtrl],
            controllerAs:"addressCtrl"
        };
        return directive;
    }

    function addressCtrl($scope){
        var vm=this;
        vm.scope=$scope;
		

    }

})();